import type { CSSProperties } from "react";

/**
 * Backdrop: fixed full-viewport scrim at the modal z-layer. On desktop it also
 * centers the dialog; on mobile the panel pins itself to inset:0 so the
 * centering is a harmless no-op. Background + z-index come from Slice-1 tokens
 * (replacing ConfirmModal's hard-coded zIndex:1000 so a drawer can't collide).
 */
export const sheetBackdropStyle: CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "var(--modal-backdrop)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: "var(--z-modal)",
};

/**
 * Panel: a centered Boardroom dialog on desktop, a full-screen sheet on mobile.
 * The mobile branch uses 100dvh (not 100vh) so the iOS URL bar can't clip the
 * sticky footer. Both branches keep the existing surface/border/shadow recipe
 * from ConfirmModal so the aesthetic is unchanged.
 */
export function sheetPanelStyle(isMobile: boolean): CSSProperties {
  const base: CSSProperties = {
    background: "var(--surface-overlay)",
    border: "1px solid var(--border)",
    boxShadow: "var(--shadow-lg)",
    display: "flex",
    flexDirection: "column",
    fontFamily: "var(--font-sans)",
    boxSizing: "border-box",
  };
  if (isMobile) {
    return {
      ...base,
      position: "fixed",
      inset: 0,
      width: "100vw",
      maxWidth: "100vw",
      height: "100dvh",
      borderRadius: 0,
    };
  }
  return {
    ...base,
    width: 480,
    maxWidth: "92vw",
    maxHeight: "90vh",
    borderRadius: 12,
  };
}
